module.exports = __webpack_public_path__ + "static/SI-On-Board-Weighing-RGB-100px-9620e8dbc88e96a668f6f6f63be8b294.png";